import { Link } from 'react-router';
import { StateMessage } from '../../../shared/components/state-message';
import { TallyLoader } from '../../../shared/components/tally-loader';
import { Wordmark } from '../../../shared/components/wordmark';
import { ROUTES } from '../../../shared/constants/app.constant';
import { useAuthCallback } from '../hooks/use-auth-callback';

export function AuthCallbackPage() {
  const { status, errorMessage } = useAuthCallback();

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center gap-8 px-5">
      <Wordmark />
      {status === 'exchanging' ? <TallyLoader label="Membuka buku kasmu" /> : null}
      {status === 'missing-token' ? (
        <StateMessage
          tone="error"
          title="Link login tidak lengkap"
          description="Link ini tidak membawa token. Kirim /login ke bot untuk mendapatkan link baru."
          action={<BackToLogin />}
        />
      ) : null}
      {status === 'failed' ? (
        <StateMessage
          tone="error"
          title="Tidak bisa masuk"
          description={
            errorMessage ?? 'Link sudah kedaluwarsa atau sudah dipakai. Kirim /login ke bot untuk link baru.'
          }
          action={<BackToLogin />}
        />
      ) : null}
    </main>
  );
}

function BackToLogin() {
  return (
    <Link to={ROUTES.login} className="text-sm font-medium text-ink underline underline-offset-4">
      Kembali ke halaman masuk
    </Link>
  );
}
